export function getReturnPath(location) {
  return location?.state?.returnTo || null;
}

export function navigateAfterFormSave(navigate, location, defaultPath) {
  const returnTo = getReturnPath(location);
  if (returnTo) {
    navigate(returnTo, {
      replace: true,
      state: { reloadCustomer: Date.now() },
    });
    return;
  }
  navigate(defaultPath);
}
